module.exports = class Parser {
    static parse() {
        throw new Error("Parser must have a parse function");
    }
};
